/**
 * Identifiant NU d'un membre LinkedIn, quelle que soit la forme d'URN reçue.
 *
 * LinkedIn désigne la même personne sous plusieurs URN selon l'API et l'époque :
 * `urn:li:fs_miniProfile:ACoAA…` (miniProfile historique), `urn:li:fsd_profile:ACoAA…`
 * (dash, vers lequel les comptes migrent progressivement)… Le seul invariant est le
 * suffixe (`ACoAA…`) : c'est LUI que PerfectPost stocke dans `users.entityUrn` et
 * compare pour décider d'un « conflit de compte ». Toute forme préfixée qui atteint
 * une comparaison ou une écriture est un bug — cf. le faux conflit permanent d'un
 * compte migré vers `fsd_profile`, que les handlers ne dépréfixaient pas.
 *
 * Le préfixe est retiré TANT qu'il en reste un : un URN imbriqué
 * (`urn:li:fsd_profile:urn:li:member:…`) n'a pas été observé, mais un seul passage
 * en laisserait un derrière lui sans que rien ne le signale.
 *
 * ⚠️ Ce paquet est front-only : le serveur ne l'importe pas à l'exécution. La copie
 * MIROIR `normalizeLinkedInMemberUrn` de `common/src/utils/` doit rester identique —
 * toute évolution ici se reporte là-bas, avec ses tests (patron `ASSISTANT_LOCALES`).
 */
const LINKEDIN_URN_PREFIX = /^urn:li:[a-zA-Z_]+:/;

export const normalizeLinkedInMemberUrn = (urn: string | undefined): string | undefined => {
  if (urn === undefined) {
    return undefined;
  }
  let bare = urn;
  while (LINKEDIN_URN_PREFIX.test(bare)) {
    bare = bare.replace(LINKEDIN_URN_PREFIX, '');
  }
  return bare;
};
